module.exports = __webpack_public_path__ + "static/media/instagram-logos.d3eb96ce.webp";